let _this;
import userRegistration from './userRegistration.vue'
import vehicleRegistration from  './vehicleRegistration.vue'
import scrollLoadList from '../commonComponents/scrollLoadList.vue'
import quickSetDCSZone from './quickSetDCSZone.vue';

export default {
  name: "fast-registration",
  components: {userRegistration,vehicleRegistration,scrollLoadList,quickSetDCSZone},
  data() {
    return {
      registerType: 0, /*注册类型 0 : user 1 : vehicle*/
      searchKeyword: '', /*搜索user关键字*/
      registerModal: false, /*注册弹框*/
      queryList: [], /*查询结果列表*/
      areaList: [], /*区域列表*/
      totalCount:0,/*搜索总数*/
      checkModal:false,/*手动通行*/
      checkInfo:{},
      deviceList:[],
      siteFlag:false,
      checkVehicleModal:false,
      checkVehicleInfo:{},
      configurationName : '',
      searchVehicleWord: '' ,/*搜索车辆关键字*/
      vehicleList:[],
      barrierGateList:[],
      accessZoneList:[],
      registerVehicleModal:false,
      curPage:1,/*当前页码*/
      queryTimer:'',
      acDetailModal:false,
      acTitleData:[],
      acTableData:[],
      operateInfo:{},
      acValidityFlag:false,
      acInfo:{
        startTime:'',
        endTime:''
      },
      // 添加startTimeInfo与startTimeInfo 用来保存开始于结束的时间信息用来禁用时间选择器
      startTimeInfo:{
        year:'',
        month:'',
        day:'',
        hour:'',
        minutes:'',
        seconds:''
      },
      endTimeInfo:{
        year:'',
        month:'',
        day:'',
        hour:'',
        minutes:'',
        seconds:''
     },
      options1:{
        disabledDate(date) {
          return date.valueOf() <  new Date().getTime() - 86400000;
        }
      },
      // 判断结束日期的禁用
      options2:{
        disabledDate(date) {
          return date.valueOf() <  new Date().getTime() - 86400000;
        }
      },
       // 判断结束时间的禁用
      timePickerOptions:{
        disabledHours:[],
        disabledMinutes:[]
      },
      acValiditySetModal:false,
      reactiveStatus:0, /* -1 小于开始时间 -2大于结束时间 */
      fastRoles:[
        '','M_EditVisitor', 'M_EditVendor'
      ]
    }
  },
  mounted() {
    _this = this;
    this.initRegisterType();
    eventBus.$on('closeRegistration', () => {
      _this.registerModal = false;
      _this.$root.swipeCardInfo = {};
    });
    eventBus.$on('closeVehicleRegistration', () => {
      _this.registerVehicleModal = false;
    });
    eventBus.$on('openRegistration', (data) => {
      if(data.Operand === 'CardContentText' && data.Param && data.Param.CARD_MAINID){
        _this.registerModal = false;
        _this.$root.swipeCardInfo = {};
        let cardData = data.Param;
        _this.$root.swipeCardInfo = {
          name:cardData['姓名'] || cardData['Name'] || cardData['英文姓名'] || cardData['English name'] || cardData['Name(Thai)'],
          idNumber:cardData['工号'] || cardData['FIN']|| cardData['No.'] || cardData['IDENTITY CARD NO.'] || cardData['ID Number'] || cardData['Passport number'] || cardData['护照号码'] || cardData['身份证号码'] || cardData['身份号码'] || cardData['驾照号码'] || cardData["Driver's license number"] || cardData['公民身份号码'] || cardData['ID card Number'],
        };
        if((cardData['First name'] && cardData['Last name']) || (cardData['名'] && cardData['姓'])){
          _this.$root.swipeCardInfo.name = (cardData['First name'] || cardData['名']) + ' ' + (cardData['Last name'] || cardData['姓']);
        }
       // console.log(_this.$root.swipeCardInfo.name,_this.$root.swipeCardInfo.idNumber);
        // 去除前后空格，name存在分号截取
        let cardInfo = {
          name:_this.$root.swipeCardInfo.name ? _this.$root.swipeCardInfo.name.trim() : '',
          idNumber:_this.$root.swipeCardInfo.idNumber ? _this.$root.swipeCardInfo.idNumber.trim() : ''
        };
        let index = cardInfo.name.indexOf(';');
        if(index > -1){
          _this.$root.swipeCardInfo = {
            name:cardInfo.name.substr(0,index),
            idNumber:cardInfo.idNumber
          }
        }else{
          _this.$root.swipeCardInfo = {
            name:cardInfo.name,
            idNumber:cardInfo.idNumber
          }
        }
        _this.searchKeyword = (_this.$root.swipeCardInfo.name || _this.$root.swipeCardInfo.idNumber);
        if(_this.searchKeyword){
          _this.getQuery(true);
        }else{
          _this.messageNotice('error','The identification is abnormal, please swipe the card again')
        }
      }
    });
    eventBus.$on('openVehicleRegistration', (message) => {
      _this.registerVehicle(message);
    });
    eventBus.$on('closeModel', () => {
      _this.registerModal = false;
    });
  },
  beforeDestroy() {
    eventBus.$off('closeRegistration');
    eventBus.$off('closeVehicleRegistration');
    eventBus.$off('openRegistration');
    eventBus.$off('openVehicleRegistration');
    eventBus.$off('closeModel');
  },
  watch:{
    // 监听变化用来 禁用时间
    'acInfo.startTime':{
      handler(newValue,oldValue){
        let time = new Date(newValue).getTime();
        let endTime = new Date(this.acInfo.endTime).getTime();
        this.options2 = {
          disabledDate(data){
            return data.valueOf()  <= time - 86400000;
          }
        }
        if(newValue >= endTime){
          this.updateEndTime()
        }
        this.updateTimeInfo();
        this.UpdateTimePickerOptions()
      }
    },
    // 监听变化用来 禁用时间
    'acInfo.endTime':{
      handler(newValue,oldValue){
        let startTime = new Date(this.acInfo.startTime).getTime();
        let newDate = new Date().getTime();
        if(startTime >= newValue || newDate >= newValue){
          this.updateEndTime()
        }
        this.updateTimeInfo();
        this.UpdateTimePickerOptions()
      }
    }
  },
  methods: {
    // 改下结束时间
    updateEndTime(){
      let startData = this.common.formatDate(this.acInfo.startTime,_this.$root.Time[_this.$root.Time.type].typeDateHM,1);
      this.acInfo.endTime = startData.split(' ')[0] + ' 23:59';
    },
    // 更新结束时间的日期禁用
    UpdateTimePickerOptions(){
       let disabledHours = [];
       let disabledMinutes = [];
       let newHover =Number(new Date().getHours());
       let newMins = Number(new Date().getMinutes());
       if(_this.acInfo.startTime && _this.compareEndTimeIsStartTimeDate()){
        // 结束时间和当前日期一样，并且与开始日期一样
        let hour = null;
        if(this.compareEndTimeIsNewDate()){
            hour =  newHover > _this.startTimeInfo.hour?newHover:this.startTimeInfo.hour
        }else{
            hour = this.startTimeInfo.hour
        }
       
        for(let i = 0;i< hour;i++){
          disabledHours.push(i)
        }
        if(hour == _this.endTimeInfo.hour){
          let minutes = null
          if(this.compareEndTimeIsNewDate()){
            minutes =   newMins > _this.startTimeInfo.minutes && newHover === this.endTimeInfo.hour?newMins:this.startTimeInfo.minutes
        }else{
            minutes = this.startTimeInfo.minutes
        }
          for(let i = 0;i< minutes;i++){
            disabledMinutes.push(i)
          }
        }

      }
      this.timePickerOptions = {
          disabledHours,
          disabledMinutes
       }
    },
    // 判断是否结束时间和当天是同一天
    compareEndTimeIsNewDate(){
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let day = new Date().getDate()
      return (this.endTimeInfo.year == year) && (this.endTimeInfo.month == month) && (this.endTimeInfo.day == day)
   },
    // 判断是否结束时间和开始时间是同一天
    compareEndTimeIsStartTimeDate(){
       return (this.endTimeInfo.year == this.startTimeInfo.year) && (this.endTimeInfo.month == this.startTimeInfo.month) && (this.endTimeInfo.day == this.startTimeInfo.day)
    },
    
    //更新开始时间和结束时间的时间信息
    updateTimeInfo(){
      if(this.acInfo.startTime){
        let date = new Date(this.acInfo.startTime);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        this.startTimeInfo = {
            year,
            month,
            day,
            hour,
            minutes,
            seconds
        }
      }else{
        this.startTimeInfo = {
          year:'',
          month:'',
          day:'',
          hour:'',
          minutes:'',
          seconds:''
        }
      }
      if(this.acInfo.endTime){
        let date = new Date(this.acInfo.endTime);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        this.endTimeInfo = {
            year,
            month,
            day,
            hour,
            minutes,
            seconds
        }
      }else{
        this.endTimeInfo ={
          year:'',
          month:'',
          day:'',
          hour:'',
          minutes:'',
          seconds:''
       }
      }
    },
    // 初始化注册类型
    initRegisterType:function () {
      let nodeId = ( _this.$root.curNodeInfo && _this.$root.curNodeInfo.id ) || _this.$root.masterNodeInfo.id;
      window.eventBus.$ajax.get('SystemSetting/GetNodeSettings?queryNodeId=' + nodeId,{headers: {noLoading: true}}).then(function (res) {
        if(res.data.success){
          let registerTypes = res.data.data['system.setting.node.quick.registration.user.enable'];
          if(_this.ApiService){
            _this.ApiService.fastRegistrationSet.Visitor = registerTypes.indexOf(1) > -1;
            _this.ApiService.fastRegistrationSet.Vendor = registerTypes.indexOf(2) > -1;
          }
        
          let text = '';
          if(_this.ApiService.fastRegistrationSet.Visitor){
            text = _this.ApiService.visitorName + 's: ';
          }
          if(_this.ApiService.fastRegistrationSet.Vendor){
            text = _this.ApiService.vendorName + 's: ';
          }
          if(_this.ApiService.fastRegistrationSet.Visitor && _this.ApiService.fastRegistrationSet.Vendor){
            text = _this.ApiService.vendorName+'s and '+ _this.ApiService.visitorName+'s: ';
          }
          if(!_this.ApiService.fastRegistrationSet.Visitor && !_this.ApiService.fastRegistrationSet.Vendor){
            _this.registerType = 1;
          }
          _this.configurationName = text;
          console.log( _this.configurationName)
        }
      }) 
      if(_this.$root.adminInfo.permissionCodes.indexOf('M_ViewAndSearchUser') <= -1 && _this.$root.adminInfo.permissionCodes.indexOf('M_ViewAndSearchVehicle') > -1){
        _this.registerType = 1;
      }
    },
    changeQueryType:function(type){
      _this.registerType = type;
      _this.searchKeyword = '';
      _this.searchVehicleWord = '';
    },
      /********************************************************user start***************************************************************************/
    // 查询结果
    getQuery: function (isSwipe) {
      _this.curPage = 1;
      _this.queryList = [];
      $('.result-list-panel').slideDown(300);
      clearTimeout(this.queryTimer);
      this.queryTimer = setTimeout(()=>{
        _this.queryUser(isSwipe);
      },500);
    },
    // 用户查询
    queryUser: function (isSwipe) {
      let userTypes = [];
      if(_this.ApiService.fastRegistrationSet.Visitor){
        userTypes.push(1);
      }
      if(_this.ApiService.fastRegistrationSet.Vendor){
        userTypes.push(2);
      }
      let searchParams = {
        enabledPaging: true,
        page:_this.curPage,
        perPage:10,
        sortType:1,
        sortName:'name',
        quickString: _this.searchKeyword,
        userTypes: userTypes,
        queryNodeId: this.$root.curNodeInfo.id,
      };
      if(this.$root.curOfficeInfo.id){
        searchParams.officeIds = [this.$root.curOfficeInfo.id];
      }else{
        delete searchParams.officeIds ;
      }
      this.$ajax.post('User/QuickRegistrationPaging',searchParams,{headers:{noLoading:true}}).then(function (res) {
        if(res.data.success){
          _this.totalCount = res.data.data.itemCount;
          if(_this.searchKeyword !== ''){
            res.data.data.items.forEach(item => {
              item.displayName = item.name;
              if(item.ids.length > 0){
                item.displayIc = item.ids[0].no;
                if (item.ids[0].no.indexOf(_this.searchKeyword) > -1) {
                  item.displayIc = item.displayIc.replace(_this.searchKeyword, "<span style='color: #00cbff'>" + _this.searchKeyword + "</span>");
                }
              }
              if (item.name.indexOf(_this.searchKeyword) > -1) {
                item.displayName = item.displayName.replace(_this.searchKeyword, "<span style='color: #00cbff'>" + _this.searchKeyword + "</span>");
              }
            });
            _this.queryList = _this.queryList.concat(res.data.data.items);
            // 刷卡没有查到人,打开注册弹框
            if(isSwipe && _this.queryList.length === 0){
              _this.registerUser(true);
            }
          }else{
            _this.queryList = [];
          }
        }else{
          _this.messageNotice('error',res.data.message);
        }
      });
    },
    // 用户注册
    registerUser: function (isSwipe) {
      // 手动打开
      if(!isSwipe){
        _this.$root.swipeCardInfo = {};
      }
      this.registerModal = true;
      this.searchKeyword = '';
      $('.result-list-panel').slideUp(300);
    },
    // 编辑用户
    editUser: function (user,reactiveFlag) {
      this.searchKeyword = '';
      this.$root.menu.navTitle = 'User';
      if(_this.$route.query.userId !== user.id){
        if (user.userType === 1) {
          this.$router.push({path: '/editVisitor', query: {userId: user.id,isReactive:reactiveFlag}});
          this.$root.menu.childTitle = 'Visitor'
          this.$root.menu.thirdTitle = 'Edit Visitor Profile'
        }
        else if (user.userType === 2) {
          this.$router.push({path: '/editVendor', query: {userId: user.id,isReactive:reactiveFlag}});
          this.$root.menu.childTitle = 'Vendor'
          this.$root.menu.thirdTitle = 'Edit Vendor Profile'
        }
      }
      $('.result-list-panel').slideUp(300);
    },
    // 用户Check
    userCheck: function (user, status) {
      this.checkInfo = {  targetNodeId: _this.$root.curNodeInfo.id,userId: user.id, checkStatus: status, remarks: "", deviceId: "", siteId:''};
      this.getAreaList(status);
      this.checkModal = true;
    },
    getAreaList:function (status) {
      this.$ajax.get('MonitoringArea/GetDefaultMonirotingAreaCheckInSite?type=' + (status === 0 ? 1 : 0),{headers:{noLoading:true}}).then(function (res) {
        if(res.data.success){
          _this.areaList = res.data.data;
          let defaultArea = _this.areaList.find(item => item.isDefault);
          if(_this.areaList.length > 0 && defaultArea){
            _this.checkInfo.siteId = defaultArea.accessSiteId;
            _this.checkInfo.accessZoneId = defaultArea.accessZoneId;
            _this.changeArea(defaultArea);
          }
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    // 选择area
    changeArea:function (area) {
      this.deviceList = [];
      _this.siteFlag = false;
      _this.deviceList = area.devices;
      _this.checkInfo.siteId = area.accessSiteId;
      _this.checkInfo.accessZoneId = area.accessZoneId;
      let defaultDevice = area.devices.find(item => item.isDefault);
      if(defaultDevice){
        _this.checkInfo.deviceId = defaultDevice.deviceId;
      }
    },
    // 保存check信息
    saveCheckInfo:function () {
      if(_this.checkInfo.siteId && _this.checkInfo.deviceId){
        _this.$ajax.post('User/QuickRegistrationAccess',_this.checkInfo).then(function (res) {
          if(res.data.success){
            _this.messageNotice('success');
            _this.checkModal = false;
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }else{
        _this.siteFlag = true;
      }
    },
    /********************************************************user end***************************************************************************/

    /********************************************************vehicle end***************************************************************************/
    // 查询结果
    getQueryVehicle: function (isSwipe) {
      _this.vehicleList = [];
      _this.curPage = 1;
      $('.result-list-panel').slideDown(300);
      clearTimeout(this.queryTimer);
      this.queryTimer = setTimeout(()=>{
        _this.queryVehicle(isSwipe);
      },500);
    },
    // 车辆查询
    queryVehicle: function () {
      let searchParams = {
        enabledPaging: true,
        page:_this.curPage,
        perPage:10,
        sortType:1,
        sortName:'plateNumber',
        plateNumberOrDriverName: _this.searchVehicleWord,
        queryNodeId: this.$root.curNodeInfo.id,
      };
      if(this.$root.curOfficeInfo.id){
        searchParams.officeIds = [this.$root.curOfficeInfo.id];
      }else{
        delete searchParams.officeIds;
      }
      this.$ajax.post('Vehicle/QuickRegistrationPaging',searchParams,{headers:{noLoading:true}}).then(function (res) {
        if(res.data.success){
          _this.totalCount = res.data.data.itemCount;
          if(_this.searchVehicleWord !== ''){
            res.data.data.items.forEach(item => {
              _this.$set(item,'plateNo',item.plateNumber)
              if (item.plateNumber.indexOf(_this.searchVehicleWord) > -1) {
                item.plateNumber = item.plateNumber.replace(_this.searchVehicleWord, "<span style='color: #00cbff'>" + _this.searchVehicleWord + "</span>");
              }
              if (item.driverName && item.driverName.indexOf(_this.searchVehicleWord) > -1) {
                let str = item.driverName.replace(_this.searchVehicleWord, "<span style='color: #00cbff'>" + _this.searchVehicleWord + "</span>");
                _this.$set(item, 'driver', str);
              }
            });
            _this.vehicleList = _this.vehicleList.concat(res.data.data.items);
          }else{
            _this.vehicleList = [];
          }
        }else{
          _this.messageNotice('error',res.data.message);
        }
      });
    },
    checkArea:function(data){
      _this.siteFlag = data === ''
    },
    registerVehicle:function (message) {
      _this.registerVehicleModal = true
      if( message ){
        _this.$nextTick(()=>{
          _this.$refs.vehicleRegistration.vehicleInfo.plateNumber = message.vehicle.plateNumber;
        })
      }
    },
    editVehicle:function (data) {
      this.searchVehicleWord = '';
      if(_this.$route.query.vehicleId !== data.vehicleId) {
        this.$router.push({path: '/editVehicle', query: {vehicleId: data.vehicleId}});
      }
      $('.result-list-panel').slideUp(300);
    },

    vehicleCheck:function (vehicle , status) {
      _this.siteFlag =  false
      this.checkVehicleInfo = {
        targetNodeId: _this.$root.curNodeInfo.id,
        checkStatus:status,
        plateNumbers: [vehicle.plateNo],
        accessZoneId:'',
        remarks: "",
      };
      this.getVehicleAreaList(status);
      this.checkVehicleModal = true;
    },
    getVehicleAreaList:function(status){
      _this.accessZoneList = [];
      _this.barrierGateList = []
      _this.$ajax.get('MonitoringArea/VehicleDefault',{headers:{noLoading:false}}).then(res=>{
        _this.accessZoneList = [];
        let defaultArea = res.data.data.accessZones;
        if(status === 0){
          _this.accessZoneList = defaultArea.filter(item=>{
            return item.type  === 1
          })
        }else {
          _this.accessZoneList = defaultArea.filter(item=>{
            return item.type === 0;
          })
        }
        _this.barrierGateList = []
        _this.areaList.forEach(item=>{
          _this.barrierGateList.push({name:item.barrierGateName,id:item.accessZoneId})
        })
      })
    },
    handleAccessZoneChange:function(data){
      _this.checkVehicleInfo.barrierGateId = data.accessZoneId;
      _this.barrierGateList = [];
      _this.barrierGateList.push({name:data.barrierGateName,id:data.accessZoneId})
      _this.accessZoneFlag = false;
    },
    saveCheckVehicle:function () {
      if(!_this.checkVehicleInfo.accessZoneId || !_this.checkVehicleInfo.barrierGateId){
        _this.siteFlag = true;
        return;
      }
      let data = JSON.parse(JSON.stringify(_this.checkVehicleInfo));
      delete data.barrierGateId;
      delete data.checkStatus;
      _this.$ajax.post('VehicleAccessRecord/QuickRegistrationAccess',data).then(res=>{
        if(res.data.success){
          _this.searchVehicleWord = ''
          _this.messageNotice('success');
          _this.checkVehicleModal = false;
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    setVehicleDriverIdCard:function(row){
      let idCard = row.driverIdentityCards && row.driverIdentityCards.length > 0 ? '('+ _this.common.icType[row.driverIdentityCards[0].type].label + ' - ' + row.driverIdentityCards[0].no +')':''
      let str= row.driverName + idCard;
      return str;
    },
    // 滚动至底部数据更新
    updateData:function (type) {
      if(_this.curPage >= Math.ceil(_this.totalCount/10)){
        return;
      }
      clearTimeout(this.queryTimer);
      this.queryTimer = setTimeout(()=>{
        _this.curPage ++;
        if(type === 0){
          _this.queryUser();
        }else{
          _this.queryVehicle();
        }
      },500);
    },
    accessCodeDetails:function(row,type){
      _this.operateInfo = row;
      // 车
      if(type === 'vehicle'){
        _this.acTitleData = [{title: _this.ApiService.accessCodeName, minWidth: 200, slot:'acName'}];
        this.$ajax.post('Vehicle/QueryVehicleAccessCodeRelation' , {vehicleIds:[row.vehicleId]}).then(res =>{
          if(res.data.success && res.data.data){
            _this.acTableData.accessCodes = res.data.data;
            _this.acDetailModal = true;
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }else{
        // 人
        _this.acTitleData = [{title: _this.ApiService.accessCodeName, minWidth: 200, slot:'acName'},{title: 'DCS Access Zone', className:'dcsCol',minWidth: 200, slot:'dcsZone'}];
        if(!_this.ApiService.isOpenDCS){
          _this.acTitleData = [{title: _this.ApiService.accessCodeName, minWidth: 200, slot:'acName'}];
        }
        this.$ajax.get('User/QuickRegistrationQueryUserAccessCodeAndDcsZone?id=' + row.id).then(res =>{
          if(res.data.success){
            _this.acTableData = res.data.data;
            _this.acDetailModal = true;
          }
        })
      }
    },
    // 确认激活
    reactive(data,type){
      _this.operateInfo = data;
      _this.operateInfo.operateType = type;
      if(_this.operateInfo.operateType === 'user'){
        _this.$ajax.get('User/QuickExtendUserValidation?id=' + _this.operateInfo.id).then(res =>{
          if(res.data.success){
            _this.reactiveStatus = res.data.data;
            // 当前时间在配置之前
            if(_this.reactiveStatus === -1 && _this.ApiService.userReactiveTime){ 
              let validity = _this.ApiService.userReactiveTime.split('-');
              _this.acInfo = {
                startTime:_this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDateHM),
                endTime:_this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' ' + validity[1]
              };
              _this.acValiditySetModal = true;
              // 当前时间在配置之后
            }else if(_this.reactiveStatus === -2 && _this.ApiService.userReactiveTime){
              _this.acInfo = {
                startTime:_this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDateHM),
                endTime:_this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' 23:59:59'
              };
              _this.acValiditySetModal = true;
            }else{
              $('.result-list-panel').slideUp(300);
              _this.messageNotice('success');
            }
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }else{
        this.$ajax.get('Vehicle/QuickExtendVehicleValidation?id=' + _this.operateInfo.vehicleId).then(res =>{
          if(res.data.success){
            _this.messageNotice('success');
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }
    },
    // DCS设置
    setDCS(){
      this.$refs.quickSettingDCS.quickEditDcs(_this.operateInfo);
      this.acDetailModal = false;
    },

    quickSetACPeriod(){
      let subData = {
        userId:_this.operateInfo.id,
        startTime:_this.common.formatZoneDate(_this.acInfo.startTime,_this.$root.Time[_this.$root.Time.type].typeDateHM,1),
        endTime:_this.common.formatZoneDate(_this.acInfo.endTime,_this.$root.Time[_this.$root.Time.type].typeDateHM,1)
      }
      this.$ajax.post('User/QuickSetUserAutoAccessCodeValidation',subData).then(res =>{
        if(res.data.success){
          _this.messageNotice('success');
          _this.acValiditySetModal = false
          $('.result-list-panel').slideUp(300);
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/fastRegistration.js